import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GroupsService } from '../services/groups.service';
import { flatMap, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from '../services/user.service';

@Component({
    template: `
        <spinner *ngIf="!group"></spinner>
        <mat-card *ngIf="group">
            <mat-card-content>
                <div fxFlex="100" fxFlexFill fxLayout="row" class="image-row">
                    <div style="padding-right:25px;">
                        <group-avatar [group]="group"></group-avatar>    
                    </div>
                    <div fxFlex fxLayout="column" class="trim-container">
                        <mat-card-title fxFlex [matTooltip]="group.name">
                            <div style="overflow: hidden; white-space: nowrap;">
                                <h4 style="text-overflow: ellipsis; overflow: hidden;">{{group.name}}</h4>
                            </div>
                        </mat-card-title>
                        <div>
                            <div fxFlex class="description">{{group.description}}</div>
                        </div>
                    </div>
                    <div *ngIf="userIsAdmin" fxFlex="75px" fxLayout="column" fxLayoutAlign="center center">
                        <button mat-icon-button matTooltip="Edit Group" [routerLink]="['/settings', 'groups', group.id]">
                            <mat-icon>build</mat-icon>
                        </button>
                    </div>

                    <div fxFlex="75px" fxLayout="column" fxLayoutAlign="center center">
                        <button mat-button matTooltip="Invite to {{group.name}}" [routerLink]="['../', 'invite']"><mat-icon>person_add</mat-icon></button>
                    </div>
                    
                    <div fxFlex="75px" fxLayout="column" fxLayoutAlign="center center">
                        <group-members-indicator [group]="group"></group-members-indicator>
                    </div>
                    <div fxFlex="75px" fxLayout="column" fxLayoutAlign="center center">
                        <group-membership-button [group]="group"></group-membership-button>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
        <mat-tab-group>
            <mat-tab label="Members">
                <group-members [group]="group" [displayOnly]="true"></group-members>
            </mat-tab>
            <mat-tab label="Topics">
                <group-topics [group]="group" [displayOnly]="true"></group-topics>
            </mat-tab>
        </mat-tab-group>
    `
})
export class BrowseGroupDetailsComponent implements OnInit, OnDestroy {
    private cleanupTime = new Subject<void>();
    group: any;
    userIsAdmin: boolean;
    
    constructor(public snackBar: MatSnackBar,
                private route: ActivatedRoute, 
                private groupService: GroupsService,
                private userService: UserService) {}
    
    ngOnInit(): void {
        this.userIsAdmin = this.userService.isCurrentUserAdmin();
        this.route.parent.params
        .pipe(
            flatMap(params => this.groupService.fetchGroup(params.groupId)),
            takeUntil(this.cleanupTime)
        ).subscribe(group => this.group = group);
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}